import {React, useState} from 'react';



const AadhaarVerify = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [image, setImage] = useState("");
    const handleFileInputChange = (event) => {
    
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
          setImage(event.target.result);
        };
        reader.readAsDataURL(file);
        setSelectedFile(file); // Set the selected file

        

      };
    return (
        <div>
            <div className=" dark:bg-[#010409] bg-[#FAF7F0]">
                <div
                    className="flex flex-col items-center pt-20 "
                >
                    <div className="w-full max-w-xl p-6 bg-white dark:bg-gray-700 rounded-lg shadow-lg">
                        <div className="text-center">
                            <h1 className="mb-4 text-3xl font-bold text-gray-800 dark:text-gray-100">
                                Upload Aadhaar
                            </h1>
                        </div>
                        <div className="flex flex-col space-y-4">
                            <div className="flex flex-col space-y-4">
                                <div className="w-1/3 h-2 mx-auto mt-1 mb-6 bg-gray-200 dark:bg-gray-600 rounded-full">
                                    <div className="w-1/4 h-full text-center text-white bg-green-600 dark:bg-green-400 rounded-full"></div>
                                </div>
                                <label className="text-sm font-semibold text-gray-600 dark:text-gray-300">
                                    Upload an Image
                                </label>
                                <div className="relative bg-gray-100 dark:bg-gray-600 border rounded-lg">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileInputChange}
                                        className="absolute inset-0 w-full h-full p-4 opacity-0 cursor-pointer"
                                    />
                                    {image ? (
                                        <div className="w-full h-64">
                                            <img
                                                src={image}
                                                alt="Selected"
                                                className="object-cover w-full h-full"
                                            />
                                        </div>
                                    ) : (
                                        <img
                                            src="https://api.iconify.design/solar:gallery-send-outline.svg?color=%23525252"
                                            alt="Upload"
                                            className="w-40 h-40 m-auto"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AadhaarVerify;
